import { render, staticRenderFns } from "./AdminAddNoteModal.vue?vue&type=template&id=2b7b1f34"
import script from "./AdminAddNoteModal.vue?vue&type=script&lang=js"
export * from "./AdminAddNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports